"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UploadClient_1 = require("./UploadClient");
var base_1 = require("./api/base");
exports.base = base_1.default;
var fromUrl_1 = require("./api/fromUrl");
exports.fromUrl = fromUrl_1.default;
var fromUrlStatus_1 = require("./api/fromUrlStatus");
exports.fromUrlStatus = fromUrlStatus_1.default;
var group_1 = require("./api/group");
exports.group = group_1.default;
var groupInfo_1 = require("./api/groupInfo");
exports.groupInfo = groupInfo_1.default;
var info_1 = require("./api/info");
exports.info = info_1.default;
var multipartStart_1 = require("./api/multipartStart");
exports.multipartStart = multipartStart_1.default;
var multipartUpload_1 = require("./api/multipartUpload");
exports.multipartUpload = multipartUpload_1.default;
var multipartComplete_1 = require("./api/multipartComplete");
exports.multipartComplete = multipartComplete_1.default;
var uploadFile_1 = require("./uploadFile");
exports.uploadFile = uploadFile_1.default;
var uploadFileGroup_1 = require("./uploadFileGroup");
exports.uploadFileGroup = uploadFileGroup_1.default;
var CancelController_1 = require("./tools/CancelController");
exports.CancelController = CancelController_1.default;
exports.default = UploadClient_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/index.js
// module id = 1248
// module chunks = 68